//React
import { FunctionComponent, useEffect } from "react";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors

import { selectLocationZoomSettings } from "../../redux/selectors/select-location-zoom-settings";
import { selectIsAppLoaded } from "../../../system/redux/selectors/select-app-loaded";

//Util
import { addMapParamsToUrl } from "../../../map/functions/url/add-map-params-to-url";

/** Updates the URL with the current location data when the map is adjusted */
export const UrlManagerLocation: FunctionComponent = (props) => {
	//State Values
	const locationZoomSettings = useAppSelector(selectLocationZoomSettings);
	const appLoaded = useAppSelector(selectIsAppLoaded);

	//Check if the user has changed the map at all
	function userHasChangedMap() {
		return locationZoomSettings.lat !== 0;
	}

	//Location Info
	useEffect(() => {
		//If the user has not moved the map yet then just leave the URL as is
		if (!userHasChangedMap() || !appLoaded) {
			return;
		}

		if (window.history.pushState) {
			var currentUrl = new URL(window.location.href);

			//If the map has not been moved by the user do not update the url with the location.
			//When the map originally loads with just a url like /texas/austin we do not want the
			// location info added to the url.
			if (userHasChangedMap()) {
				currentUrl = addMapParamsToUrl(currentUrl, locationZoomSettings);

				if (currentUrl.href === window.location.href) {
					return;
				}

				window.history.pushState("", document.title, currentUrl);
			}
		}
	}, [locationZoomSettings, appLoaded]);

	return null;
};
